import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  methodology: null,
  vulnerabilities: null,
  allAssessments: [],
  customerAssessments: [],
  createAssessment: {},
  assessment: {},
  assessmentDetailData: {},
  updateAssessment: {},
  assessmentScans: {},
  assessmentControlTemplates: [],
  attachControlTemplate: {},
  detachControlTemplate: {},
  attachTemplateSection: {},
  detachTemplateSection: {},
  assessmentTemplateControls: [],
  setAssessmentControls: {},
  attachTemplateControls: {},
  detachTemplateControls: {},
  assessmentScan: {},
  assessmentControlTemplate: {},
  assessmentTemplateControl: {},
  updateAssessmentTemplateControls: {},
  requestRemediation: {},
  observations: [],
  recommendations: [],
  assessmentControlArticles: [],
  addSupportingArticles: {},
  downloadAssessmentControlArticle: {},
  updateAssessmentControlArticle: {},
  deleteAssessmentControlArticle: {},
  addRediation: {},
  isLoading: false,
  toggleModal: false,
  toggleEditModal: false,
  error: [],
  observationsData: [],
  recommendationsData: [],
};

const assessmentSlice = createSlice({
  name: 'assessment',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setMethodology: (state, action) => {
      state.methodology = action.payload;
    },
    setAllAssessments: (state, action) => {
      state.allAssessments = action.payload;
      state.isLoading = false;
    },
    setCustomerAssessments: (state, action) => {
      state.customerAssessments = action.payload;
      state.isLoading = false;
    },
    setCreateAssessment: (state, action) => {
      state.createAssessment = action.payload;
      state.isLoading = false;
    },
    setAssessment: (state, action) => {
      state.assessment = action.payload;
      state.isLoading = false;
    },
    setAssessmentScans: (state, action) => {
      state.assessmentScans = action.payload;
      state.isLoading = false;
    },
    setAssessmentControlTemplates: (state, action) => {
      state.assessmentControlTemplates = action.payload;
      state.isLoading = false;
    },
    setAttachControlTemplate: (state, action) => {
      state.attachControlTemplate = action.payload;
      state.isLoading = false;
    },
    setDetachControlTemplate: (state, action) => {
      state.detachControlTemplate = action.payload;
      state.isLoading = false;
    },
    setVulnerabilities: (state, action) => {
      state.vulnerabilities = action.payload; // state not found
      state.isLoading = false;
    },
    setAttachTemplateSection: (state, action) => {
      state.attachTemplateSection = action.payload;
      state.isLoading = false;
    },
    setDetachTemplateSection: (state, action) => {
      state.detachTemplateSection = action.payload;
      state.isLoading = false;
    },
    setAssessmentTemplateControls: (state, action) => {
      state.assessmentTemplateControls = action.payload;
      state.isLoading = false;
    },
    setUpdateAssessmentTemplateControls: (state, action) => {
      state.updateAssessmentTemplateControls = action.payload;
      state.isLoading = false;
    },
    setSetAssessmentControls: (state, action) => {
      state.setAssessmentControls = action.payload;
      state.isLoading = false;
    },
    setAssessmentControlTemplate: (state, action) => {
      state.assessmentControlTemplate = action.payload;
      state.isLoading = false;
    },
    setAssessmentTemplateControl: (state, action) => {
      state.assessmentTemplateControl = action.payload;
      state.isLoading = false;
    },
    setRequestRemediation: (state, action) => {
      state.requestRemediation = action.payload;
      state.isLoading = false;
    },
    setAssessmentControlArticles: (state, action) => {
      state.assessmentControlArticles = action.payload;
      state.isLoading = false;
    },
    setAddSupportingArticles: (state, action) => {
      state.addSupportingArticles = action.payload;
      state.isLoading = false;
    },
    setAddRediation: (state, action) => {
      state.addRediation = action.payload;
      state.isLoading = false;
    },
    setObservations: (state, action) => {
      state.observations = action.payload;
      state.isLoading = false;
    },
    setRecommendations: (state, action) => {
      state.recommendations = action.payload;
      state.isLoading = false;
    },
    setDownloadAssessmentControlArticle: (state, action) => {
      state.downloadAssessmentControlArticle = action.payload;
      state.isLoading = false;
    },
    setUpdateAssessmentControlArticle: (state, action) => {
      state.updateAssessmentControlArticle = action.payload;
      state.isLoading = false;
    },
    setDeleteAssessmentControlArticle: (state, action) => {
      state.deleteAssessmentControlArticle = action.payload;
      state.isLoading = false;
    },
    setAssessmentDetailData: (state, action) => {
      state.assessmentDetailData = action.payload;
      state.isLoading = false;
    },
    setToggleModal: (state) => {
      state.toggleModal = !state.toggleModal;
    },
    setToggleEditModal: (state) => {
      state.toggleEditModal = !state.toggleEditModal;
    },
    setObservationsData: (state, action) => {
      state.observationsData = action.payload;
    },
    setRecommendationsData: (state, action) => {
      state.recommendationsData = action.payload;
    },
    setResetAssessment: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setMethodology,
  setAllAssessments,
  setCustomerAssessments,
  setCreateAssessment,
  setAssessment,
  setAssessmentScans,
  setAssessmentControlTemplates,
  setAttachControlTemplate,
  setDetachControlTemplate,
  setVulnerabilities,
  setAttachTemplateSection,
  setDetachTemplateSection,
  setAssessmentTemplateControls,
  setUpdateAssessmentTemplateControls,
  setSetAssessmentControls,
  setAssessmentControlTemplate,
  setAssessmentTemplateControl,
  setRequestRemediation,
  setAssessmentControlArticles,
  setAddSupportingArticles,
  setAddRediation,
  setObservations,
  setRecommendations,
  setDownloadAssessmentControlArticle,
  setUpdateAssessmentControlArticle,
  setDeleteAssessmentControlArticle,
  setAssessmentDetailData,
  setResetAssessment,
  setToggleModal,
  setToggleEditModal,
  setObservationsData,
  setRecommendationsData,
} = assessmentSlice.actions;

export default assessmentSlice.reducer;
